module.exports = __webpack_public_path__ + "img/check-circle-solid.f26cf7df.svg";